<template>
  <perfect-scrollbar class="p-4 ContentsBox">

    <b-row class="mt-2">
      <b-col sm="3" class="label">
        <label class="labelText bold">申請者氏名</label>
      </b-col>
      <b-col sm="9" class="flex flexMiddle">
        {{userInfo.sei}} {{userInfo.mei}}
      </b-col>
    </b-row>

    <hr>

    <b-row class="mt-2">
      <b-col sm="3" class="label">
        <label class="labelText bold">申請者メールアドレス</label>
      </b-col>
      <b-col sm="9" class="flex flexMiddle">
        {{mailInfo.login_id}}
        <span v-if="isDeletedUser" class="error">
          ユーザーが削除されているため、メール送信はできません。
        </span>
      </b-col>
      <b-col sm="3" v-if="mailInfo.has_invalid_email_address"></b-col>
      <b-col sm="9" v-if="mailInfo.has_invalid_email_address"
        class="flex flexMiddle error">
        システムからこのユーザーへのメールが届かなかったため、このユーザーへのメール送信はブロックされています。<br>
        ユーザーがログインに成功すると、ブロックが解除されます。
      </b-col>
    </b-row>

    <hr>

    <b-row class="mt-2">
      <b-col sm="3" class="label">
        <label class="labelText bold">現在のステータス</label>
      </b-col>
      <b-col sm="9" class="flex flexMiddle">
        {{statusTexts[status]}}
      </b-col>
    </b-row>

    <hr>

    <b-row class="">
      <b-col sm="3" class="label">
        <label class="labelText bold">ステータス</label>
      </b-col>
      <b-col sm="4">
        <b-form-select
          class="h-50px"
          @input="updateStatus"
          :value="newStatus"
          :options="newStatusList"
          :disabled="!onGoing || isEnd">
          <template v-slot:first>
            <option :value="null">-- 選択してください。 --</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <hr>

    <b-row class="mb-3">
      <b-col sm="3" class="label">
        <label
          :class="[
            'labelText',
            'bold',
            !canInputReason ? 'opacity03' : '',
          ]">
          差戻・棄却理由</label>
      </b-col>
      <b-col sm="9">
        <b-form-textarea
          @input="updateReason"
          :value="reason"
          :disabled="!canInputReason || !onGoing"
          :rows="10"
          />
      </b-col>
    </b-row>

    <div>
    </div>

  </perfect-scrollbar>
</template>

<script>
import CONST_STATUS from '@/constants/appStatus';


export default {
  name: 'cmsApplicationControl',
  components: {
  },
  props: {
    status: { type: Number, default: null },
    mailInfo: { type: Object, default: () => {} },
    onGoing: { type: Boolean },
  },
  data() {
    return {
      nowIndex: this.pageIndex,
      statusTexts: CONST_STATUS.APP_STATUS_TEXTS,
      newStatusList: CONST_STATUS.CMS_APP_STATUS_OPTION,
    };
  },
  methods: {
    updateStatus(value) {
      this.$store.commit('cmsApplicationControl/updateStatus', value);
    },
    updateReason(value) {
      this.$store.commit('cmsApplicationControl/updateReason', value);
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo.inputData;
    },
    canInputReason() {
      const hasReasonStatusList = CONST_STATUS.HAS_REASON_STATUS;
      return hasReasonStatusList.indexOf(Number(this.newStatus)) !== -1;
    },
    newStatus() {
      return this.$store.state.cmsApplicationControl.status;
    },
    reason() {
      return this.$store.state.cmsApplicationControl.reason;
    },
    isDeletedUser() {
      return Object.keys(this.mailInfo).length === 0;
    },
    isEnd() {
      // 採択、不採択、棄却
      return this.status === 10 || this.status === 11 || this.status === 12;
    },
  },
  // ロード画面
  created() {
  },
};
</script>

<style scoped>
  .opacity03 {
    opacity: 0.3;
  }

  .h-50px {
    height: 50px;
  }

  .label {
    height: 50px;
  }

  .labelText {
    position: absolute;
    top: 10px;
  }

  .error {
    color: #dc3545;
  }
</style>
